<template>
  <div
    :class="[
      'media-gallery',
      `el-size--${size}`,
      loading ? 'loading' : '',
      css
    ]"
  >
    <inner-search v-if="withSearch" :search-string.sync="searchString" />

    <preloader v-show="loading"></preloader>
    <!-- v-if="filteredChildren.length > itemsPerPage" -->
    <paginate
      ref="paginator"
      name="filteredChildren"
      :list="filteredChildren"
      :per="itemsPerPage"
      tag="div"
      :key="filteredChildren.length"
    >
      <transition-group
        v-bind:css="false"
        ref="list"
        name="list"
        class="media-gallery--items"
        tag="div"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        appear
      >
        <div
          v-for="(item, i) in paginated('filteredChildren')"
          :data-index="i"
          :key="item.title + i"
          class="media-gallery--item"
          @click="
            setGalleryIndex(itemsPerPage * paginate.filteredChildren.page + i)
          "
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
          appear
        >
          <div class="media-gallery--item--image" :style="imageStyle(item)">
            <!-- <i :class="['media-icon', 'fal', 'fa-play-circle']"></i> -->
            <i :class="['media-icon', 'play-circle-icon']">
              <i class="fal fa-triangle"></i>
            </i>
            <!-- <img :src="parseSrc(item.image)" alt="" /> -->
          </div>
          <h4 class="text-gray-8 bg-gray-1" v-text="item.title"></h4>
        </div>
      </transition-group>
    </paginate>
    <transition name="slide-up" appear>
      <div
        class="pager py-xl"
        v-if="
          !!filteredChildren.length && filteredChildren.length > itemsPerPage
        "
      >
        <paginate-links
          id="pager"
          ref="pager"
          for="filteredChildren"
          :limit="4"
          :show-step-links="true"
          @change="onLangsPageChange"
          :step-links="{ next: localize('Next'), prev: localize('Prev') }"
        ></paginate-links>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    hasSearch: {
      type: Boolean,
      default: false
    },
    /*
      True in case the component is a partial (not minified version)
      and not expanded on a whole page
    */
    css: String,
    isPartial: {
      type: Boolean,
      default: false
    },
    size: String,
    properties: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      paginate: ["filteredChildren"],
      index: -1,
      // itemsPe rPage: 9,
      loading: false,
      searchString: null
    };
  },
  mounted() {
    this.setGalleryChildren(this.filteredChildren);
    window.addEventListener("resize", this.reshow, false);
  },
  methods: {
    ...mapActions(["setGalleryIndex", "setGalleryChildren"]),
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(80%)";
    },
    enter: function(el, done) {
      let lapse = 180,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(80%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    },
    imageStyle(item) {
      if (item.image.indexOf("http") < 0) {
        return `background-image: url(${this.$imageFolder}/${item.image})`;
      }
      return `background-image: url(${item.image})`;
    },
    parseSrc(img) {
      // console.log(" >this.$imageFolder >> ", this.$imageFolder);
      if (/http/.test(img)) {
        return img;
      }
      return `${this.$imageFolder}/${img}`;
    },
    reshow() {
      this.loading = true;
      setTimeout(
        function() {
          this.loading = false;
        }.bind(this),
        800
      );
    },
    onLangsPageChange() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  computed: {
    ...mapState(["dimensions"]),
    itemsPerPage() {
      return this.dimensions.width < 815 ? 8 : 12;
    },
    filteredChildren() {
      if (this.searchString && this.searchString.length > 1) {
        return this.children.filter(child => {
          let __s = (child.title + child.sub_title).toLowerCase();
          return __s.indexOf(this.searchString.toLowerCase()) > -1;
        });
      }
      return this.children;
    },
    withSearch() {
      if (this.properties && _.has(this.properties, "hasSearch")) {
        return this.properties.hasSearch;
      }
      return this.hasSearch;
    }
  }
};
</script>

<style lang="stylus">
.media-gallery
  position relative
  &.loading
    height 84vh
    .pager
      opacity 0
      height 0
      overflow hidden
  &--items
    _flex(row, wrap, stretch, stretch)
    /.loading &
      opacity 0
      overflow hidden
    +below(815px)
      _flex(row, wrap, stretch, space-between)
  &--item
    flex 0 0 33.33%
    border 10px solid #fff
    // border-left 0
    cursor pointer
    _flex(column, wrap, flex-start, flex-start)
    &:nth-child(3n+3)
      border-right 0
    &:nth-child(3n+1)
      border-left 0
    +below(815px)
      flex 0 0 calc(50% - 10px)
      marg('2xl', bottom)
      border 0
      +portrait()
        flex 0 0 100%
        marg('2xl', bottom)
        border 0
    h4
      padding 30px 30px 35px
      font-size 18px
      flex 1
      width 100%
      +below(1370px)
        padding 20px 20px 25px
      +below(815px)
        padding 10px 10px 15px
    &--image
      height 26vh
      position relative
      overflow hidden
      object-fit cover
      background-size cover
      background-repeat 0 0
      background-position 50% 50%
      width 100%
      .media-icon
        opacity 0
        backface-visibility hidden
        center()
        transform translate(-50%, -50%) scale(0.5)
        z-index 9
        font-size responsive 20px 34px
        color rgba(#fff, 0.8)
        transform-style preserve-3d
        will-change opacity, transform, box-shadow
        box-shadow 0 0 5px rgba(0,0,0,0)
        transition opacity 0.7s ease-out-expo, transform 0.7s ease-out-expo, box-shadow 0.7s ease-out-expo
        &.play-circle-icon
          display inline-flex
          align-items center
          justify-content center
          round(90)
          border 3px solid rgba(#fff, 0.8)
          i
            transform rotate(-29deg)
      &:after
        content ''
        position absolute 0 0 0 0
        opacity 0
        background rgba(gray_8, 0.2) url(/img/dark-net.png) repeat 0 0
        z-index 8
        transition opacity 0.7s ease-out-expo
      img
        position absolute
        top 50%
        left 50%
        transform translate(-50%,-50%)
        height 100%
        min-width 100%
        min-height 100%
        transition transform 0.8s ease-out-quint
    // &:nth-child(1)
    // &:nth-child(2)
    //   flex 0 0 48%
    //   .media-gallery--item--image
    //     height 40vh
    +desktop()
      &:hover
        h4
          background blue_4
          color #fff
        .media-gallery--item--image
          &:after
            opacity 0.4
        img
          transform translate(-50%,-50%) scale(1.1)
        .media-icon
          opacity 0.8
          transform translate(-50%, -50%) scale(1)
          box-shadow 0 0 55px rgba(0,0,0,0.6)
</style>
